// Investor tour step definitions — used by both admin overlay tour and public demo page.
export const TOUR_STEPS = [
  {
    id: "landing",
    route: "/",
    title: "Part 1 — The $8T Market",
    anchor: '[data-testid="landing-hero"], main, section',
    narration: "Delta GreenX is structured trade infrastructure for the $8T global food trade.",
    script:
      "This is the top of the funnel. The landing page positions Delta GreenX against the $8T+ global food trade system, with clear CTAs for Buyers, Exporters, and Investors. Walk through the market reality stats, the 4-step 'How It Works', and the Early Access Network — controlled onboarding, not open marketplace.",
    highlights: ["$8T+ addressable market", "$2.5T+ annual trade inefficiency", "30–90 day cash cycles"],
  },
  {
    id: "overview",
    route: "/admin",
    title: "Part 2 — Admin Command Center",
    anchor: '[data-testid="admin-layout"]',
    narration: "The operator cockpit: applications, capital flows, and the AI Confidence Engine status.",
    script:
      "The Command Center is where trade actually gets executed. You can see live applications from Buyers and Exporters, $825K in structured capital flows, and our AI Confidence Engine active across every deal — real model, not a demo stub.",
    highlights: ["10+ applications", "$825K capital volume", "AI Confidence Engine online"],
  },
  {
    id: "deals",
    route: "/admin/deals",
    title: "Part 3 — AI Confidence Engine",
    anchor: '[data-testid="deals-list"], [data-testid="admin-layout"]',
    narration: "Dual-layer risk scoring: rule-based + Delta GreenX AI deep analysis.",
    script:
      "Click 'Risk' on any deal to open the Delta GreenX AI Confidence Engine. Rule-based scoring runs instantly. Press 'Run AI Confidence Analysis' and our engine returns an executive summary, ranked risks with severity, actionable mitigations, market intelligence, a pricing assessment, and a recommended capital structure. This is commercial intelligence before a dollar moves.",
    highlights: ["Rule-based + AI dual-layer", "Delta GreenX AI engine", "Recommended capital structure"],
  },
  {
    id: "flow",
    route: "/admin/capital-flows",
    title: "Part 4 — Flow Engine & Returns",
    anchor: '[data-testid="admin-layout"]',
    narration: "Milestone-linked capital + live returns lifecycle — capital deployed, fees earned, buyer savings.",
    script:
      "The Flow Engine is not payments — it's execution-linked capital. Every flow shows the full lifecycle: capital deployed, platform fee earned by Delta GreenX, buyer working-capital savings vs traditional trade finance, and days saved. Capital Pending $180K, Execution $115K, In Transit $360K, Capital Released $170K — $825K total capital deployed, generating a platform revenue pipeline of ~$19.8K on this batch alone.",
    highlights: ["$825K capital deployed", "$19.8K revenue pipeline", "~2.4% avg platform fee", "59 days saved vs traditional"],
  },
  {
    id: "supply-chain",
    route: "/admin/supply-chain",
    title: "Part 5 — Supply Chain Mapping",
    anchor: '[data-testid="admin-supply-chain"]',
    narration: "End-to-end: Exporter → Importer → Distributor → Ultimate Buyer — with multi-source corporate intelligence.",
    script:
      "We map the entire chain from origin to shelf. 9 ultimate buyers across 10,543 locations representing $144.5M in annual downstream purchasing power. Our infrastructure compresses the traditional 79-day settlement cycle to 20 days — a 75% acceleration. Multi-source corporate intelligence validates every node with credit ratings, registry IDs, and risk indicators.",
    highlights: ["9 ultimate buyers / 10,543 locations", "$144.5M downstream", "79d → 20d (75% cut)"],
  },
  {
    id: "velocity",
    route: "/admin/velocity",
    title: "Part 6 — Capital Velocity",
    anchor: '[data-testid="admin-layout"]',
    narration: "Every dollar deployed — how many times it rotates back into the chain.",
    script:
      "Deploying capital isn't the metric — rotating it is. Capital Velocity tracks deployed capital, rotations completed, and throughput per exporter and importer. This is how investors price the unit economics: velocity × margin = effective yield.",
    highlights: ["Rotations per entity", "Throughput per dollar", "Investor unit economics"],
  },
  {
    id: "profiles",
    route: "/admin/profiles",
    title: "Part 7 — Multi-Source KYC & Commercial Intelligence",
    anchor: '[data-testid="admin-layout"]',
    narration: "Aggregated public-registry signals across India, USA, Singapore, UK, Australia.",
    script:
      "Every counterparty has a commercial profile sourced from the appropriate authoritative public registry across India, USA, Singapore, Australia, and the UK. We normalize registry ID, credit rating, financial strength, annual revenue, and KYC status across geographies — the trust layer that makes structured capital possible. All registry signals are presented for orientation only; full KYC is conducted under formal review with counterparty consent.",
    highlights: ["Multi-source corporate intelligence", "IN · US · UK · SG · AU coverage", "Normalized across 11 profiles / 7 countries"],
  },
];

export const DEMO_TOKEN = process.env.REACT_APP_PUBLIC_DEMO_TOKEN || "dgx-investor-2026";
